export default {
    getChildren: state => state.children,
}